import heroVindicta from "../../assets/pictures/hero-vindicta-up-720.webp";

/* The hero art.

   An ESP overlay (a head lock with name, distance and health) was tried on
   her here and taken off again: on the landing page it read as odd rather
   than as a demonstration. The login page keeps its own version, where the
   art is a panel beside a form rather than the site's opening picture. */

/* Desktop: the figure beside the headline, placed so the barrel lands on the
   Products tab. Solved numerically over offset and rotation together; it came
   out as pure translation, so she stays upright. The fixed offset survives
   resizing because the hero grid and the nav are both centred containers and
   the art has a fixed max-width. Measured off-target: 1.0deg at 1280px, 0.1 at
   1388, 0.9 at 1750. */
export const HeroFigure = () => (
  <img
    src={heroVindicta}
    alt=""
    aria-hidden
    className="relative block h-auto w-full max-w-[27rem] translate-x-[60px] translate-y-[50px]"
    width={900}
    height={1572}
    /* The largest thing on the first screen, so the one Google times as the
       page's load (LCP): first in the queue. */
    loading="eager"
    fetchPriority="high"
    decoding="async"
  />
);

/* Phones: the art is hidden below lg, so the first screen on a phone was text
   over an empty skyline. A band from just above her head to her waist,
   centred on her body (59% across the picture), fading in at the top and out
   at the bottom. */
export const HeroArtBand = () => (
  <div
    aria-hidden
    className="relative mx-auto mt-10 h-[22rem] max-w-sm overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_7%,black_72%,transparent)] lg:hidden"
  >
    <div className="absolute left-1/2 top-0 w-[112%] -translate-x-[59%] -translate-y-[17%]">
      {/* Same file as the desktop figure, so one download serves both. Eager
          and high priority: on a phone this band is the largest thing near the
          first screen, which makes it the LCP element. */}
      <img
        src={heroVindicta}
        alt=""
        width={900}
        height={1572}
        className="block h-auto w-full"
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </div>
  </div>
);
